/**
 * 本地存储工具函数（封装 LocalStorage/SessionStorage）
 * 无需挂载全局，组件按需导入即可
 */

// -------------------- LocalStorage 操作（永久存储） --------------------
/**
 * 读取 LocalStorage
 * @param {string} key - 存储键名
 * @returns {any} 存储值（自动反序列化）
 */
export const getLocalStorage = (key) => {
    if (!key) return null
    try {
        const value = localStorage.getItem(key)
        return value ? JSON.parse(value) : null
    } catch (error) {
        console.error('读取 LocalStorage 失败：', error)
        return null
    }
}

/**
 * 写入 LocalStorage
 * @param {string} key - 存储键名
 * @param {any} value - 存储值（自动序列化）
 */
export const setLocalStorage = (key, value) => {
    if (!key) return
    try {
        localStorage.setItem(key, JSON.stringify(value))
    } catch (error) {
        console.error('写入 LocalStorage 失败：', error)
    }
}

/**
 * 删除 LocalStorage 某一项
 * @param {string} key - 存储键名
 */
export const removeLocalStorage = (key) => {
    if (!key) return
    localStorage.removeItem(key)
}

// -------------------- SessionStorage 操作（临时存储） --------------------
export const getSessionStorage = (key) => {
    if (!key) return null
    try {
        const value = sessionStorage.getItem(key)
        return value ? JSON.parse(value) : null
    } catch (error) {
        console.error('读取 SessionStorage 失败：', error)
        return null
    }
}

export const setSessionStorage = (key, value) => {
    if (!key) return
    try {
        sessionStorage.setItem(key, JSON.stringify(value))
    } catch (error) {
        console.error('写入 SessionStorage 失败：', error)
    }
}

// -------------------- SessionStorage 存储或者设置语言值 --------------------
export const getLanguageSessionStorage = () => {
    const key = 'language_session_storage_key'
    try {
        const value = sessionStorage.getItem(key)
        return value ? JSON.parse(value) : null
    } catch (error) {
        console.error('读取 language_session_storage_key 失败：', error)
        return null
    }
}

export const setLanguageSessionStorage = (value) => {
    const key = 'language_session_storage_key'
    try {
        sessionStorage.setItem(key, JSON.stringify(value))
    } catch (error) {
        console.error('写入 language_session_storage_key 失败：', error)
    }
}